/**
 * @deprecated This service has been consolidated into src/services/github/GitHubService.ts
 * This file is maintained for backward compatibility only.
 * Please update imports to use: import { GitHubService } from './github';
 */

import { GitHubService } from './github/GitHubService';

interface ScaffoldRepositoryParams {
  userId: string;
  projectId: string;
  repoName: string;
  repoDescription: string;
  isPrivate: boolean;
  manifestData?: {
    files: Array<{
      path: string;
      content: string;
    }>;
  };
}

interface ScaffoldResult {
  success: boolean;
  repoUrl?: string;
  error?: string;
}

export class GitHubScaffoldService {
  static async scaffoldRepository(
    params: ScaffoldRepositoryParams
  ): Promise<ScaffoldResult> {
    return GitHubService.scaffoldRepository(
      params.userId,
      params.projectId,
      params.repoName,
      params.repoDescription,
      params.isPrivate,
      params.manifestData
    );
  }
}

// Export for backward compatibility
export const GithubScaffoldService = GitHubScaffoldService;
